export default "__VITE_ASSET__CIRl3NS4__"